import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useLayoutEffect, useState, useRef } from 'react';
import { Button, Col, Input, InputGroupAddon, Row } from 'reactstrap';
import DropdownSelect from '../../../../ProposalGenerator/DropdownSelect';
import Toggle from '../../../../Toggle';
import InfoPopup from '../../../../InfoPopup';

function NetworkInput(props) {
  const {
    header,
    onChange,
    onPing,
    onToggle,
    value,
    name,
    leftToggle,
    rightToggle,
    radioList,
    disabled,
    placeholderNone,
    onPingPress,
    input,
    dropdownOptions,
    selectedOption,
    onOptionSelect,
    radioValue,
    onRadioChange,
    selectedRadio,
    showEye,
    tooltipId,
    tooltipText,
  } = props;
  const [showPass, setShowPass] = useState(false);
  const [type, setType] = useState(showEye ? 'password' : 'text');
  const inputRef = useRef(null);

  useLayoutEffect(() => {
    if (showEye) {
      setType(!showPass ? 'text' : 'password');
    }
  }, [showPass]);

  const handlePassChange = React.useCallback(e => {
    e.preventDefault();
    setShowPass(prev => !prev);
  }, []);

  return (
    <Row className="network-input-container">
      <Col sm={6} className="d-flex">
        {header}
        {tooltipId && tooltipText && (
          <sup>
            <InfoPopup id={tooltipId} text={tooltipText} />
          </sup>
        )}
      </Col>
      <Col sm={6}>
        {' '}
        {input && (
          <Row>
            <Col sm={12}>
              <Input
                ref={inputRef}
                disabled={disabled}
                placeholder={placeholderNone ? '' : 'Please specify'}
                type={type}
                value={value}
                name={name}
                onChange={onChange}
              />
              {showEye && (
                <InputGroupAddon
                  addonType="append"
                  className="show-password"
                  styles={{ top: '5px !important' }}
                  onClick={handlePassChange}
                >
                  <FontAwesomeIcon
                    icon={showPass ? 'eye' : 'eye-slash'}
                    size="lg"
                    color="#8998ac"
                  />
                </InputGroupAddon>
              )}
            </Col>
          </Row>
        )}
        {onToggle && (
          <Row>
            {leftToggle && (
              <Col sm={3} id="pricing-toggle-M">
                {leftToggle}
              </Col>
            )}
            <Col sm={4} style={{ display: 'flex', verticalAlign: 'middle' }}>
              <Toggle disabled={disabled} value={value} onToggle={onToggle} />
            </Col>
            {rightToggle && (
              <Col sm={3} id="pricing-toggle-M">
                {rightToggle}
              </Col>
            )}
          </Row>
        )}
        {dropdownOptions && (
          <Row>
            <Col sm={12}>
              <DropdownSelect
                disabled={disabled}
                options={dropdownOptions}
                selectedOption={selectedOption}
                onSelect={onOptionSelect}
              />
            </Col>
          </Row>
        )}
        {radioList &&
          radioList.map(item => {
            return (
              <Col sm={12}>
                <Input
                  disabled={disabled}
                  checked={true}
                  type="radio"
                  name={item.name}
                  onChange={e => onRadioChange(e, item.radioName)}
                />
                {item.radioName}
              </Col>
            );
          })}
      </Col>
    </Row>
  );
}

export default NetworkInput;
